export default {
  Java: `public class largestPrime {
      static boolean isPrime(long factor) {
          double endPoint = Math.sqrt(factor);
          int i = 2;
          while (i <= endPoint){
              if (factor % i == 0){
                  return false;
              }
              i++;
          }
          return true;
      }
          
      static long runner(long n) {
          double endPoint = Math.sqrt(n);
          long largest = n; 
          int i = 1;
          while (i <= endPoint){
              if (n % i == 0 && isPrime(i)){
                  n = n/i;
                  largest = i;
              }
              i++;
          }
          //System.out.println(largest);
          if (n > 1 && isPrime(n)){
              return n;
          }
          return largest;
      }
      public static void main(String args[]) {
          System.out.println(runner(600851475143L));
      }
  }
  `,
  JavaScript: `function runner(n){
    const endPoint = parseInt(Math.sqrt(n));
    let largest = n, i = 1;
    while (i <= endPoint) {
      if (n % i === 0 && isPrime(i)) {
        n = n / i;
        largest = i;
      }
      i++;
    }
    if (n > 1 && isPrime(n)) {
      return n;
    }
    console.log(largest);
  };

  //check if factor is a prime
  function isPrime(factor) {
    const endPoint = parseInt(Math.sqrt(factor));
    let i = 2;
    while (i <= endPoint) {
      if (factor % i === 0) {
        return false;
      }
      i++;
    }
    return true;
}
runner(600851475143)`,
  Python: `import math
  def isPrime(factor):
      endPoint = math.sqrt(factor)
      i = 2
      while (i <= endPoint):
          if (factor % i == 0):
              return False
          i += 1
      return True
      
  def runner(n):
      endPoint = math.sqrt(n)
      largest = n; i = 1
      while (i <= endPoint):
          if (n % i == 0 and isPrime(i)):
              n = n/i
              largest = i
          i += 1
      if (n > 1 and isPrime(n)):
          return n
      return largest
      
  print(runner(600851475143))
`,
};
